import { createSlice } from "@reduxjs/toolkit";

export const InvoiceInitialState = {
  invoice: [],
  factures: [],
  proforma: [],
  bonLivraisons: [],
  invoices: [],
  invoiceLog: [],
  
  // Persistent state for Factures
  facturesPageIndex: 0,
  facturesSearchQuery: '',
  
  // Persistent state for Proforma
  proformaPageIndex: 0,
  proformaSearchQuery: '',
  
  // Persistent state for BonLivraisons
  bonLivraisonPageIndex: 0,
  // bonLivraisonSearchQuery: '',
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState: InvoiceInitialState,
  reducers: {
    setInvoice: (state, action) => {
      state.invoice = action.payload.invoice;
    },
    setFactures: (state, action) => {
      state.factures = action.payload.factures;
    },
    setProforma: (state, action) => {
      state.proforma = action.payload.proforma;
    },
    setInvoices: (state, action) => {
      state.invoices = action.payload.invoices;
    },
    setBonLivraisons: (state, action) => {
      state.bonLivraisons = action.payload.bonLivraisons;
    },
    setInvoiceLog: (state, action) => {
      state.invoiceLog = action.payload.invoiceLog;
    },
    
    // Factures persistence
    setFacturesPageIndex: (state, action) => {
      state.facturesPageIndex = action.payload;
    },
    setFacturesSearchQuery: (state, action) => {
      state.facturesSearchQuery = action.payload;
    },
    
    // Proforma persistence
    setProformaPageIndex: (state, action) => {
      state.proformaPageIndex = action.payload;
    },
    setProformaSearchQuery: (state, action) => {
      state.proformaSearchQuery = action.payload;
    },
    
    // BonLivraisons persistence
    setBonLivraisonPageIndex: (state, action) => {
      state.bonLivraisonPageIndex = action.payload;
    },
    // setBonLivraisonSearchQuery: (state, action) => {
    //   state.bonLivraisonSearchQuery = action.payload;
    // },
  },
});

export const {
  setInvoice,
  setFactures,
  setProforma,
  setInvoices,
  setBonLivraisons,
  setInvoiceLog,
  setFacturesPageIndex,
  setFacturesSearchQuery,
  setProformaPageIndex,
  setProformaSearchQuery,
  setBonLivraisonPageIndex,
  // setBonLivraisonSearchQuery,
} = invoiceSlice.actions;